import React, { Suspense } from "react";
import { Limit } from "../../../../models/Limit";
import * as yup from "yup";
import { TFunction } from "i18next";

export const StepTitle3 = (t: TFunction) => t("step3.title");
export const StepInstructions3 = (t: TFunction) => t("step3.instructions");
export const StepValidation3 = (t: TFunction) =>
  yup.object({
    stacks: yup.array().min(1, t("validation.stacks.min", { min: 1 })),
  });

const Step3Lazy = React.lazy(() =>
  import("./Step3Lazy").then(({ Step3Lazy }) => ({
    default: Step3Lazy,
  }))
);

interface Step3Props {
  limit: Limit;
  requireNonDicomAnnotation: boolean;
}

export const Step3: React.FC<Step3Props> = ({
  limit,
  requireNonDicomAnnotation,
}) => {
  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <Step3Lazy
          limit={limit}
          requireNonDicomAnnotation={requireNonDicomAnnotation}
        />
      </Suspense>
    </div>
  );
};
